import { Expose, Type } from 'class-transformer';

import { SortDirection } from '@angular/material/sort';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';
import { Theme } from '@lib/ui/theme';
import { UserGlobalInterfaceConfig } from './user-global-interface-config';

export class SnUserMapSettings extends SnModel {
  @Expose()
  public lat: number;

  @Expose()
  public lon: number;

  @Expose()
  public zoomLevel: number;

  @Expose()
  public lockToolbar: boolean;

  @Expose()
  public cadColumns: any;

  @Expose()
  public slewToCueDockCameras: boolean;

  @Expose()
  public favoriteIcons: string[] = [];

  @Expose()
  public enabledAlertReasons: any[];

  @Expose()
  public disabledAlertTypes: any[];

  @Expose()
  public alertsBoundary: any;

  @Expose()
  public cadPriorityFilters: any[];

  @Expose()
  public disabledCadFilters: any[];

  @Expose()
  public displayedCadFilters: string[];

  @Expose()
  public activeCadFilters: any;

  @Expose()
  public defaultSortColumn: string;

  @Expose()
  public defaultSortDirection: SortDirection;

  @Expose()
  public selectedInnerLayers: string[];

  @Expose()
  public selectedDynamicLayers: string[];

  @Expose()
  public selectedCameraStatuses: string[];

  @Expose()
  public selectedLprMakes: string[];

  @Expose()
  public disabledClusterFilters: string[];

  @Expose()
  public isRoomClearingEnabled: boolean;

  @Expose()
  public isLprMigrated: boolean;

  @Expose()
  public cadWidgetOn: boolean;

  @Expose()
  public disabledTeams: string[];

  @Expose()
  public confirmDockDeviceLivestream: boolean;

  @Expose()
  public confirmGridDeviceLivestream: boolean;

  @Expose()
  public hasShownAxonDevicesDrawer: boolean;

  @Expose()
  public hasTurnedOnAxonDevicesLayer: boolean;

  @Expose()
  public hasShownWelcome: boolean;

  @Expose()
  public hasEnabledFleetLprAlertLayers: boolean;

  @Expose()
  public displayCameraLabels: boolean;

  @Expose()
  public displayCameraLabelsOnlyZoomed: boolean;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}

export class SnUserSettings extends SnModel {
  @Expose()
  public theme: Theme;

  @Expose()
  public defaultMapTeamLayer: string;

  @Expose()
  @Type(() => SnUserMapSettings)
  public mapSetting: SnUserMapSettings;

  @Expose()
  public streamNotificationSound: boolean;

  @Expose()
  public dashboardConfiguration: any;

  @Expose()
  public notificationSoundPlayCount: number;

  @ExposeRawData()
  public layerSetting: any;

  @ExposeRawData()
  public cadFilters: any;

  @ExposeRawData()
  public alertsBoundary: any;

  @Expose()
  authTokens?: {
    axonconnect?: {
      accessToken?: string;
      refreshTokenExpiresIn?: number;
      scope?: string;
      features?: {
        respond: boolean;
        alpr: boolean;
      };
      region?: string;
      domain?: string;
      baseDomain?: string;
      expiresIn?: number;
      isSso?: boolean;
      obtained?: string;
    };
  };

  @ExposeRawData()
  public userGlobalInterfaceConfig?: UserGlobalInterfaceConfig;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
